import React from 'react';
import aboutImg from '../assets/images/aboutus.png';

const AboutUs = () => {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12">
          <div className="md:w-1/2">
            <img src={aboutImg} alt="Bitdeploy Team Collaboration" className="rounded-lg shadow-xl w-full" />
          </div>
          <div className="md:w-1/2">
            <h3 className="text-base uppercase font-semibold text-blue-600">About Bitdeploy</h3>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 my-3">
              Empowering Businesses with Scalable IT Solutions
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              At Bitdeploy, we understand the unique technological challenges faced by businesses in Western Canada. Our mission is to deliver comprehensive IT infrastructure and data security solutions that simplify your operations, secure your critical assets, and empower your growth. With years of industry experience, we are your trusted partner for customized, scalable, and secure IT services, from network architecture to data destruction.
            </p>
            <a href="#services" className="bg-gray-800 hover:bg-gray-900 text-white font-bold py-3 px-8 rounded-lg transition duration-300">
              Our Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;